import React from "react";
import { Text } from "react-native";
import { AppFontStyle } from "../../styles/AppFontStyle";
import { AppColors } from "../../utility/AppColors";

const HelpCenterTitleComponent = ({ title }) => {
  return (
    <Text
      style={[
        AppFontStyle.BOLD_ANYBODY_14,
        {
          fontSize: 24,
          fontWeight: "800",
          lineHeight: 27.72,
          textAlign: "left",
          marginBottom: 20,
          color: AppColors.white,
        },
      ]}
    >
      {title}
    </Text>
  );
};

export default HelpCenterTitleComponent;
